<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline :title="title">
      <!-- <v-btn class="add-audit-offline"
        v-on:click="()=>{$router.push({ name: 'addAudit', params: {type: 'online'} })}"
        v-if="isWrite" elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
        <v-icon left>mdi-plus</v-icon>
        Add Audit
      </v-btn> -->
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10"
          style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-component>

        <!--Filter header start -->
        <v-row>
          <v-col class="mt-2" cols="12" sm="3">
            <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
              :return-value.sync="date" transition="scale-transition" offset-y max-width="290px"
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="date" label="Month" prepend-icon="mdi-calendar" readonly
                  v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="date" type="month" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(date);getAcadAudits()">
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="font-weight-medium body-2">
              Staff
            </label>
            <v-autocomplete class="my-0 py-1" placeholder="--All Staff--" name="sectionSelect"
              v-model="staff" required v-on:change="getClassList();getAcadAudits()" :items="staffOptions"
              key="user.id" item-value="user.id" item-text="user.firstName">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="font-weight-medium body-2">
              Class
            </label>
            <v-autocomplete class="my-0 py-1" placeholder="--Select class--" name="sectionSelect"
              v-model="selectedClassId" required v-on:change="getAcadAudits()" item-value="id"
              :items="classList" key="id" item-text="name">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <label>Score Range</label>
            <v-range-slider v-model="range" :max="max" :min="min" hide-details class="align-center">
              <template v-slot:prepend>
                <v-text-field label="Start Range" :value="range[0]" class="mt-0 pt-0" hide-details
                  single-line type="number" min="0" max="100" style="width: 60px"
                  @change="$set(range, 0, $event);"></v-text-field>
              </template>
              <template v-slot:append>
                <v-text-field label="End Range" :value="range[1]" class="mt-0 pt-0" hide-details
                  single-line type="number" min="0" max="100" style="width: 60px"
                  @change="$set(range, 1, $event);"></v-text-field>
              </template>
            </v-range-slider>
          </v-col>
          <v-col class="mt-2" sm="3">
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search" append-icon="mdi-magnify" class="ml-auto mb-2" label="Search"
              hide-details single-line style="max-width:350px;" />
          </v-col>

          <v-col cols="12" md="3" lg="2">
            <span class="font-weight-medium body-2">Action</span>
            <div class="inside">
              <v-btn elevation="1" color="success" @click="getAcadAudits()">
                <v-icon left>mdi-magnify</v-icon>Search
              </v-btn>
            </div>
          </v-col>

        </v-row>
        <!--Filter header end -->

        <!--Data table start -->
        <v-data-table :headers="headers" :items="auditData" disable-pagination hide-default-footer>

          <template v-slot:item.actions="{ item }">
            <v-btn v-if="!item.isPublish" color="success" class="px-2 ml-1 ma-1" min-width="0"
              v-on:click="()=>{$router.push({ name: 'editAudit', params: {id: item.id} })}" small>
              <v-icon small> mdi-pencil </v-icon>
            </v-btn>
            <v-btn color="success" class="px-2 ml-1 ma-1" min-width="0" small
              v-on:click="()=>{$router.push({ name: 'viewAudit', params: {id: item.id} })}">
              <v-icon small> mdi-eye </v-icon>
            </v-btn>
            <!-- <v-btn color="success" v-else class="px-2 ml-1 ma-1" min-width="0" small>
              <v-icon small> mdi-reload </v-icon>
            </v-btn> -->
          </template>

          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
        <!--Data table end -->

        <!--Pagination start-->
        <v-row>
          <v-col cols="4" sm="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
              @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" :total-visible="totalPages"
              @input="handlePageChange">
            </v-pagination>
          </v-col>
        </v-row>
        <!--Pagination end-->
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['id'],
  async created () {
    this.franchiseeID = this.id
    await this.getfranchiseeDetails()
    await this.getClassList()
    await this.getAcadAudits()
    await this.getTeacherList()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    academicYear: async function (val) {
      console.log(val)
      this.academicYearID = val.id
      this.getClassList()
      this.getAcadAudits()
      this.getTeacherList()
    }
  },
  data () {
    return {
      isWrite: true,
      search: '',
      franchiseeID: this.id,
      title: 'Individual Centre List',
      academicYearID: '',
      selectedClassId: '',
      classList: [],
      auditData: [],
      auditDataCopy: [],
      min: 0,
      max: 100,
      range: [0, 100],
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      totalPages: 0,
      headers: [
        { text: 'Staff Name', value: 'auditeeDetails', sortable: true },
        { text: 'Score', value: 'overallScore', sortable: true },
        { text: 'Date', value: 'auditDate', sortable: true },
        { text: 'Class', value: 'classDetails', sortable: true },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ],
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false,
      scoreOptions: [],
      score: '',
      staffOptions: [],
      staff: ''
    }
  },
  methods: {
    getTeacherList: async function () {
      if (this.franchiseeID) {
        // staff/teacher-class-map
        let rows = await http.get(`${constants.API_URL}/api/staff/approved`, {
          params: {
            franchiseeID: this.franchiseeID,
            isTeachingStaff: true
          }
        })
        console.log('____Teacher list___', rows.data)
        this.staffOptions = rows.data
        this.staffOptions.unshift({
          user: {
            id: '',
            firstName: 'All'
          }
        })
      }
    },
    getAcadAudits: async function () {
      try {
        if (this.franchiseeID && this.academicYear.id) {
          let rows = await http.get(`${constants.API_URL}/api/center-audit/audit`, {
            params: {
              franchiseeID: this.franchiseeID,
              academicYearID: this.academicYear.id,
              classID: this.selectedClassId,
              page: this.page - 1,
              size: this.pageSize,
              search: this.search,
              auditeeID: this.staff,
              startRange: this.range[0],
              endRange: this.range[1],
              month: parseInt(moment(this.date).month()) + 1
            }
          })
          this.auditData = rows.data.rows.map((item) => {
            item.auditeeDetails = `${item.auditeeName[0].firstName} ${item.auditeeName[0].lastName}`
            item.classDetails = item.className[0].name
            item.auditDate = moment(item.auditDate).format('LL')
            return item
          })
          this.totalPages = rows.data.totalPages
          // this.staff = ''
          // this.auditDataCopy = [...this.auditData]
          console.log('__Audit Data__', this.auditData)
        } else {
          let message = 'Something went wrong!'
          if (!this.academicYear?.id) {
            message = 'Please select an acadamic year.'
          }
          this.$buefy.toast.open({
            message: message,
            type: 'is-danger',
            duration: 1000
          })
        }
      } catch (e) {
        return this.$dialog.error({
          text: (e && e.response && e.response.data.message) || e.message,
          title: 'Error'
        })
      }
    },
    filterBasedOnStaff () {
      this.auditData = this.auditDataCopy.filter((item) => {
        if (this.staff === '') {
          return item
        }
        return item.auditeeID === this.staff
      })
    },
    filterBasedOnMonth (date) {
      this.auditData = this.auditDataCopy.filter((item) => {
        return moment(item.auditDate).format('MMMM') === moment(date).format('MMMM')
      })
    },
    getClassList: async function () {
      console.log('Get Class List Method')
      if (this.academicYear.id) {
        if (this.staff === '' || this.franchiseeID === '') {
          // Fetching all classes
          let rows = await http.get(`${constants.API_URL}/api/center-audit/audit/getAllClassesByfranchisee`, {
            params: {
              franchiseeID: this.franchiseeID,
              academicYearID: this.academicYear.id
            }
          })
          this.classList = rows.data
        } else {
          // Classes based on teacher selection
          let rows = await http.get(`${constants.API_URL}/api/staff/teacher-class-map`, {
            params: {
              franchiseeID: this.franchiseeID,
              academicYearID: this.academicYear.id,
              userID: this.staff,
              isActive: true
            }
          })
          this.classList = rows.data.map((item) => {
            return item.studentSection.studentClass
          })
        }

        this.classList.unshift({
          id: '',
          name: 'All'
        })
        this.selectedClassId = '' // Selecting all classes as options may vary based on selection
        this.getAcadAudits() // Cause for second toast error of franchisee selection
      } else {
        console.log('Class list fetch failed')
      }
    },
    getfranchiseeDetails: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee/${this.id}`)
        this.title = response.data.companyName
      } catch (e) {}
    },
    handlePageChange: function () {
      console.log(`Page: ${this.page}`)
      this.getAcadAudits()
    },
    handlePageSizeChange: function () {
      console.log(`Page Size: ${this.pageSize}`)
      this.getAcadAudits()
    }
  }
}
</script>

<style scoped>
.add-audit-offline {
  position: absolute;
  right: 170px;
  top: 15px;
}
.add-audit-online {
  position: absolute;
  right: 180px;
  top: 0;
}
</style>
